export default __webpack_public_path__ + "static/media/refresh-svgrepo-com.1336615f.svg";